export default "__VITE_ASSET__Cp3fHZTt__"